import { Routes } from '@angular/router';

import { MapTrafficComponent } from './map-traffic/map-traffic.component';



export const routes: Routes = [
    { path: 'map/shelter/:s', component: MapTrafficComponent },
    { path: 'map/shelter/:s/:x/:y', component: MapTrafficComponent },
    { path: '**', redirectTo: '/map/shelter/w' },
];
